/**
 * User API
 * 
 * Handles user-related API calls including:
 * - Getting current user data
 * - Getting active trips
 */

import api from './client';

export const userApi = {
  /**
   * Get current user data
   * @returns {Promise<Object>} User data
   */
  async getCurrentUser() {
    const response = await api.get('/api/user');
    return response.data;
  },

  /**
   * Get user's active trips
   * @returns {Promise<Object|null>} Active trip data or null
   */
  async getActiveTrips() {
    const response = await api.get('/api/user_trips');
    const data = response.data;

    if (!data || Object.keys(data).length === 0) {
      return null;
    }

    return data;
  },
};

export default userApi;
